<template>
  <div class="c-config-content">
    <h4 class="c-config-content__title">{{ $t('apiRoute') }}</h4>
    <div>
      <div class="c-template-table table-responsive c-role-table">
        <table class="table table-hover">
          <thead>
          <tr style="background-color: #F1F5FB">
            <th>{{ $t('apiRouteName') }}</th>
            <th>{{ $t('ext') }}</th>
            <th class="th-80 text-right">
            </th>
          </tr>
          </thead>
          <tbody v-if="items.length">
          <tr v-for="item in items" :key="item._id">
            <td>{{ item.name }}</td>
            <td>{{ item.ext }}</td>
            <td class="text-right">
              <button @click="update(item._id)" class="btn btn-outline-gray btn-sm"
                      type="button">
                <font-awesome-icon icon="info"/>
              </button>
            </td>
          </tr>
          </tbody>
          <tbody v-else>
          <tr>
            <td colspan="3" class="text-center text-gray-999">{{ $t('noAPIRouteFound') }}</td>
          </tr>
          </tbody>
        </table>
      </div>
      <b-modal v-model="showForm" :title="$t('apiRouteFormTitle')" @ok="save" no-close-on-backdrop
               no-enforce-focus>
        <div class="row">
          <div class="col">
            <form-input :label="$t('apiRouteName')" :model="formModel" attribute="name" :errors="formErrors" :placeholder="$t('apiRouteNamePlaceholder')"></form-input>
            <form-input :label="$t('ext')" :model="formModel" attribute="ext" :errors="formErrors" :placeholder="$t('apiRouteExtPlaceholder')"></form-input>
            <form-input :label="$t('apiUrl')" :model="formModel" attribute="apiUrl" :errors="formErrors" :placeholder="$t('apiUrlExtPlaceholder')"></form-input>
            <target-select :label="$t('failedTarget')" :model="formModel" attribute="failedTarget" :errors="formErrors"></target-select>
          </div>
        </div>
        <template v-slot:modal-footer>
          <b-button variant="secondary" class="float-right" @click="showForm = false">{{ $t('close') }}
          </b-button>
        </template>
      </b-modal>
    </div>
  </div>
</template>

<script>
import list from '@/mixins/List';
import crud from '@/mixins/CRUD';
import TargetSelect from "@/components/ClientTargetSelect.vue";

export default {
  props: ['client'],
  mixins: [list, crud],
  components: {TargetSelect},
  data: function () {
    return {
      service: '/api-route',
      autoLoad: true,
      defaultFilterFormModel: {
        client: this.client._id
      },
    }
  },
  i18n: {
    messages: {
      vi: {
        apiRoute: "Định tuyến bằng API",
        apiRouteName: "Tên định tuyến",
        apiRouteFormTitle: "Thông tin định tuyến",
        apiUrl: "API URL",
        failedTarget: "Đích đến nếu API không trả về kết quả hoặc trả về sai",
        close: "Đóng",
        noAPIRouteFound: "Chưa có định tuyến bằng API nào được thiết lập",
      },
      en: {
        apiRoute: "Định tuyến bằng API",
        apiRouteName: "Tên định tuyến",
        apiRouteFormTitle: "Thông tin định tuyến",
        apiUrl: "API URL",
        failedTarget: "Đích đến nếu API không trả về kết quả hoặc trả về sai",
        close: "Đóng",
        noAPIRouteFound: "Chưa có định tuyến bằng API nào được thiết lập",
      }
    }
  }
}
</script>